import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import LogHelper from '../helpers/log.helper';
import { ApiPaginatedResponse, ApiResponse } from '../utils/api-response.utils';
import {
  // CategoryInsight,
  CategoryInsightPowerBIDashboard,
  HistoricalAccuracy,
} from '../models/category-insights.model';

@injectable()
export class CategoryInsightsService {
  logger: LogHelper;

  constructor(logger = new LogHelper()) {
    this.logger = logger;
  }

  // async getCategoryInsights(): Promise<ApiPaginatedResponse<CategoryInsight>> {
  //   try {
  //     const response = await axiosClient.get<
  //       ApiPaginatedResponse<CategoryInsight>
  //     >('/api/category-insights/reports');
  //     return response.data;
  //   } catch {
  //     throw new Error(ERRORS.unexpectedError);
  //   }
  // }

  async getPresignedUrl(
    categoryInsightId: number
  ): Promise<ApiResponse<string>> {
    const response = await axiosClient.get<ApiResponse<string>>(
      `/api/category-insights/reports/${categoryInsightId}/presigned-url?`
    );
    return response.data;
  }

  async getUserDashboard(): Promise<
    ApiPaginatedResponse<CategoryInsightPowerBIDashboard>
  > {
    try {
      const response = await axiosClient.get<
        ApiPaginatedResponse<CategoryInsightPowerBIDashboard>
      >(`/api/category-insights/dashboards`);
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getDashboardById(
    id: number
  ): Promise<ApiResponse<CategoryInsightPowerBIDashboard>> {
    try {
      const response = await axiosClient.get<
        ApiResponse<CategoryInsightPowerBIDashboard>
      >(`/api/category-insights/dashboards/${id}`);
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getHistoricalAccuracyData(): Promise<ApiResponse<HistoricalAccuracy>> {
    try {
      const response = await axiosClient.get<ApiResponse<HistoricalAccuracy>>(
        '/api/category-insights/accuracy'
      );
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
